export function getId(string) {
  return parseInt(string.substring(string.lastIndexOf("/") + 1), 10);
}

export function getDealerId(string) {
  return parseInt(string.substring(string.lastIndexOf(":") + 1), 10);
}
